import { getExternalTouchpointParameters } from '@account/account-portal/config'
import { FrontendName, getRuntimeInfo, startPasswordReset } from '@account/account-portal/lib'
import { accountConfig } from '@account/configs'
import { evaluateConfig } from '@crystal/core'
import { createGlassHttp } from '@crystal/glass-bridge'
import { getToken } from '@crystal/recaptcha'

import {
  TriggerActivationEmailRequest,
  TriggerActivationEmailResponse,
  TriggerActivationEmailErrorResponse,
} from '../types'

export const triggerActivationEmail = async (data: Omit<TriggerActivationEmailRequest, 'recaptcha'>) => {
  const { isAuthProvider } = getRuntimeInfo()
  let externalSourceId: string | undefined = undefined

  // TODO: Remove this workaround when Email team sets up the right sourceID -> https://jira.tools.3stripes.net/browse/DCACQ-1146
  if (isAuthProvider) {
    externalSourceId = getExternalTouchpointParameters()?.sourceId
    await startPasswordReset({
      email: data.email,
      sourceId: externalSourceId,
    })
  }

  const { post } = createGlassHttp({ clientTag: FrontendName })
  const { recaptchaSiteKey } = evaluateConfig(accountConfig)
  const body: TriggerActivationEmailRequest = {
    ...data,
    recaptcha: await getToken(recaptchaSiteKey, {
      action: 'start_activation',
    }),
    sourceId: externalSourceId || data.sourceId,
  }

  try {
    return await post<TriggerActivationEmailResponse, TriggerActivationEmailRequest>(
      '/api/account/request-activation',
      body,
    )
  } catch (err) {
    return Promise.reject(err as TriggerActivationEmailErrorResponse)
  }
}
